import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import ErrorMessage from '../ErrorMessage';
import RadioList, {
	RadioItemRenderItemProps,
	RadioListProps,
} from '../RadioList';
import TopFieldContent from '../TopFieldContent';
import InputWrapper from '../InputWrapper/InputWrapper';

export interface RadioListFieldProps extends RadioListProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onFieldChange?: (...event: any) => void;
	renderItem?: (props: RadioItemRenderItemProps) => React.ReactElement;
	inLine?: boolean;
	hideRequired?: boolean;
	isWrapped?: boolean;
}

const RadioListField = ({
	name,
	label,
	isRequired,
	className,
	onFieldChange,
	renderItem,
	inLine,
	hideRequired,
	isWrapped,
	...radioListProps
}: RadioListFieldProps) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: null,
	});

	const component = (
		<div className={className}>
			{label && (
				<TopFieldContent
					label={label}
					isRequired={isRequired}
					hideRequired={hideRequired}
				/>
			)}
			<RadioList
				inLine={inLine}
				renderItem={renderItem}
				{...radioListProps}
				{...field}
				{...(onFieldChange && {
					onChange: event => {
						onFieldChange?.(event);
						field.onChange(event);
					},
				})}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default RadioListField;
